// extracted by mini-css-extract-plugin
module.exports = {"indexPage":"IndexPage_indexPage__3RooI","vase":"IndexPage_vase__3A4AX"};